import { environment } from '@hakimo-ui/hakimo/environments';
import { useMutation } from 'react-query';
import { SlackMessagePayload } from './util';

/**
 * Posts a report straight to a Slack incoming webhook. Deliberately not in
 * data-access and deliberately not using useAuthenticatedMutation: Slack is
 * not our API and must never receive the user's Auth0 token.
 */
export function useSendFeedback(onSuccess?: () => void) {
  return useMutation<void, Error, SlackMessagePayload>(
    async (payload) => {
      // Form encoded, not JSON: an application/x-www-form-urlencoded POST is
      // CORS-simple, so it skips preflight (which Slack rejects) and still
      // returns a readable response. That is what lets us surface a dead or
      // rotated webhook instead of reporting success into the void.
      const response = await fetch(environment.feedbackSlackWebhook, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: `payload=${encodeURIComponent(JSON.stringify(payload))}`,
      });

      if (!response.ok) {
        const reason = await response.text();
        throw new Error(
          `Slack rejected the report (${response.status} ${reason}).`
        );
      }
    },
    { onSuccess }
  );
}

export default useSendFeedback;
